import crmService from '@/services/crmService'
export default {
  state: {
    token: localStorage.getItem('token'),
    userExternalLinks: [],
  },
  mutations: {
    SET_EXTERNAL_LINKS(state, userExternalLinks) {
      state.userExternalLinks = userExternalLinks.reverse()
    },
    ADD_EXTERNAL_LINK(state, link) {
      state.userExternalLinks.unshift(link)
    },
    DELETE_EXTERNAL_LINK(state, id) {
      state.userExternalLinks = state.userExternalLinks.filter(
        item => item.id !== id
      )
    },
  },
  actions: {
    async fetchLinksList({ commit }) {
      const { data } = await crmService.fetchUserExternalLinks()
      commit('SET_EXTERNAL_LINKS', data)
    },
    async addExternalLink({ commit }, name) {
      const { data } = await crmService.addExternalLink(name)
      commit('ADD_EXTERNAL_LINK', data)
    },
    async deleteExternalLink({ commit }, id) {
      await crmService.deleteExternalLink(id)
      commit('DELETE_EXTERNAL_LINK', id)
    },
  },
}
